function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 50
// module chunks = 0